export const hideDisciplinaryProcedures = (store = {}) => !(
  store.Military
    && store.Military.History
    && store.Military.History.HasServed
    && store.Military.History.HasServed.value === 'Yes'
);
